export default __webpack_public_path__ + "static/media/earth.cac76cce.jpg";